import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.PARTNERS].GET_AVAILABLE_PARTNERS]: {
		url: '/partners/v1/available_partners_list/:companyId/', // FIXME: fix url
	},
}
